import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from './crud.service';
import { environment } from 'src/environments/environment';
import { CreateGridProfileRequest, UpdateGridProfileRequest } from '../models/grid-profile.model';

@Injectable({
  providedIn: 'root'
})
export class GridProfileService {

  private readonly apiUrl = environment.baseApiUrl + 'grid-profiles';

  constructor(private crudService: CrudService) {}

  getProfiles(gridKey: string): Observable<any> {
    return this.crudService.getData(`${this.apiUrl}?grid_key=${encodeURIComponent(gridKey)}`);
  }

  createProfile(profile: CreateGridProfileRequest): Observable<any> {
    return this.crudService.insertData(this.apiUrl, profile);
  }

  updateProfile(id: number, profile: UpdateGridProfileRequest): Observable<any> {
    return this.crudService.updateData(this.apiUrl, id, profile);
  }

  deleteProfile(id: number): Observable<any> {
    return this.crudService.deleteData(this.apiUrl, id);
  }
}
